module.exports = __webpack_public_path__ + "static/media/staffan-sanberg.5fb84187.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/member-photos/staffan-sanberg.jpg
// module id = 212
// module chunks = 0